import { ProjectRPCSession } from '#/services/session';
import {ManifestGetRequest} from "./requests";
import {queryProjectClient} from "../../clients";
import Vue from "vue";

export class ManifestGetSession extends ProjectRPCSession {
  constructor(manifestId) {
    super();
    this.manifestId = manifestId;
    this.request = ManifestGetRequest(this.manifestId)
    this.loading = false;
    this.error = '';
  }

  async load() {
    if (this.loading) {
      return false;
    }
    this.loading = true;
    const headers = await this.headers();
    return new Promise((resolve, reject) => {
      queryProjectClient.getManifests(this.request, headers, (err, response) => {
        if (err != null) {
          console.log('received err from getJobs ', err);
          this.error = err;
          return reject(err);
        }

        const list = response.getManifestsList();
        if (list.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          const manifest = list[0];
          if (manifest) {
            Vue.set(this, 'manifest', manifest);
          }
        }

        return resolve(response);
        // TODO: commit mutations on store to set jobs
        // TODO: remove list from dispatch in jobs. - relegate to this session
        // return resolve(response.toObject());
      });
    }).finally(() => {
      this.loading = false;
    });
  }
}
